import { gql } from '@apollo/client';

export const FETCH_UNKNOWN_USER_TEMPLATE = gql`
    query FetchUnknownUserTemplate($id: ID!) {
        system {
            unknownUserTemplates(filter: { id_in: [$id] }) {
                id
                domain
                formsAuthEnabled
                locale
                defaultFirstName
                defaultLastName
                accessGroups {
                    accessGroup {
                        id
                        name
                        description
                        isInheritable
                        ## Fails with: "Cannot return null for a non-null type. Field: owner, Type: AuthDomain!."
                        # owner {
                        #     companyAlias
                        #     facilityAlias
                        # }
                        parent {
                            id
                        }
                    }
                    authDomain {
                        companyAlias
                        facilityAlias
                    }
                }
            }
        }
    }
`;
